import { getFlag } from 'sierra-client/config/global-config'

export const useSkillsFlagEnabled = (): boolean => {
  const allowNewSkills = getFlag('skills/allow-new-skills')
  return allowNewSkills
}
